import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EmployeeAPI from '../../../src/api/scheduleAssignment/api-emp-schedule-assignment';

export const fetchEmployees = createAsyncThunk('employeeSchedule/fetch', async (_, thunkAPI) => {
  try {
    const res = await EmployeeAPI.getAll();
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const addEmployee = createAsyncThunk('employeeSchedule/add', async (payload, thunkAPI) => {
  try {
    const res = await EmployeeAPI.add(payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateEmployee = createAsyncThunk('employeeSchedule/update', async (payload, thunkAPI) => {
  try {
    const res = await EmployeeAPI.update(payload.id, payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteEmployee = createAsyncThunk('employeeSchedule/delete', async (ids, thunkAPI) => {
  try {
    await EmployeeAPI.delete(ids);
    return ids;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const employeeSlice = createSlice({
  name: 'employeeSchedule',
  initialState: { list: [], loading: false, error: '' },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (s) => { s.loading = true; s.error = ''; })
      .addCase(fetchEmployees.fulfilled, (s, a) => { s.loading = false; s.list = [...a.payload]; })
      .addCase(fetchEmployees.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(addEmployee.fulfilled, (s, a) => { s.list.unshift(a.payload); })
      .addCase(updateEmployee.fulfilled, (s, a) => {
        const idx = s.list.findIndex((e) => e.id === a.payload.id);
        if (idx !== -1) s.list[idx] = a.payload;
      })
      .addCase(deleteEmployee.fulfilled, (s, a) => {
        const ids = Array.isArray(a.payload) ? a.payload : [a.payload];
        s.list = s.list.filter((e) => !ids.includes(e.id));
      });
  },
});

export default employeeSlice.reducer;
